import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { store, persistor } from "./store.js";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import GoogleLoginPage from "./components/login/googlelogin/GoogleLoginPage.jsx";
import ManualLogin from "./components/login/ManualLogin.jsx";
import DashboardPayments from "./components/payments/disbursement/DashboardPayments.jsx";
import WithheldPanel from "./components/payments/withheldpanel/WithheldPanel.jsx";
import BankBulkUpdate from "./components/payments/bulkbankupdate/BankBulkUpdate.jsx";
import BankBoxPanel from "./components/payments/bankboxpanel/BankBoxPanel.jsx";
import BankBoxFlags from "./components/payments/BankBoxFlags.jsx";
import PaymentsAdminPanel from "./components/payments/adminpanel/PaymentsAdminPanel.jsx";
import ResourcePanel from "./components/payments/ResourcePanel.jsx";
import Details from "./components/details/Details.jsx";
import NotFound from "./layouts/NotFound.jsx";
import ProtectedRoute from "./components/auth.jsx";
import EnvConfig from "./components/envconfig/EnvConfig.jsx";
import ErrorBoundary from "./layouts/ErrorBoundaries.jsx";
import CronsPanel from "./components/payments/CronsPanel.jsx";
import { getAppName } from "./utils/appConfig";

function App() {
  useEffect(() => {
    document.title = `:: ${getAppName()} ::`;
  }, []);

  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <ErrorBoundary>
              <Routes>
                <Route path="/" element={<GoogleLoginPage />} />
                <Route
                  path="/healthcheck"
                  element={"Service is up and running."}
                />
                {+process.env.REACT_APP_DISABLE_MANUAL_LOGIN ? (
                  <Route path="/manuallogin" element={<Navigate to="/" />} />
                ) : (
                  <Route path="/manuallogin" element={<ManualLogin />} />
                )}
                <Route
                  path="/payments/disbursement_list"
                  element={
                    <ProtectedRoute>
                      <DashboardPayments />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/withheld_maker_list"
                  element={
                    <ProtectedRoute>
                      <WithheldPanel />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/bank_payment_panel"
                  element={
                    <ProtectedRoute>
                      <BankBulkUpdate />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/bank_box_panel"
                  element={
                    <ProtectedRoute>
                      <BankBoxPanel />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/details"
                  element={
                    <ProtectedRoute>
                      <Details />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/bank_box_flag_config"
                  element={
                    <ProtectedRoute>
                      <BankBoxFlags />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/payments_admin_panel"
                  element={
                    <ProtectedRoute>
                      <PaymentsAdminPanel />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/manage_env_config"
                  element={
                    <ProtectedRoute>
                      <EnvConfig />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/resource_panel"
                  element={
                    <ProtectedRoute>
                      <ResourcePanel />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/payments/crons_panel"
                  element={
                    <ProtectedRoute>
                      <CronsPanel />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </ErrorBoundary>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
